export const PLATFORM = "Smarter Intelligence";
export const PLATFORM_ABBR = "SI";
export const LEGAL_SELLER = "Smarter Choice Investment Holdings LLC";
export const TECH_ENTITY = "Millionaire Mindsetters Technologies";
export const FOUNDATION = "Millionaire Mindsetters Foundation";
export const BRAND_INITIALS = "SI";
export const FOUNDER = "Carl Cheatham";
export const PHONE = "832-981-3352";
export const PHONE_HREF = "tel:+18329813352";

export const COMMITMENT =
    "A portion of every Smarter Choice engagement funds the Millionaire Mindsetters Foundation's small-business and financial-literacy programs.";
export const PURCHASE_DISCLAIMER =
    "Consulting services are quoted after a free consultation; scope and fees are confirmed in writing before any payment. Digital products and subscriptions show their price before checkout.";
export const NO_GUARANTEE =
    "Agencies, lenders, investors, and registries make their own decisions under their own rules. We do not guarantee approvals, awards, funding, filing acceptance, or any outcome.";
export const NOT_LAW_FIRM =
    "Smarter Choice is not a law firm, CPA firm, lender, or government agency and does not provide legal, tax, or investment advice. Where a licensed professional is required, we refer you to one or coordinate with yours.";
export const TAGLINE = "Start it. Run it. Protect it. Fund it.";
